module.exports = __webpack_public_path__ + "static/media/very-rare-achiev.0c12099c.png";